import React from "react";
import styles from "./FullScreenLoader.module.scss";

function FullScreenLoader() {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.loadingContainer}>
        <span className={styles.circle}></span>
        <span className={styles.circle}></span>
        <span className={styles.circle}></span>
        <span className={styles.circle}></span>
      </div>
    </div>
  );
}

export default FullScreenLoader;
